export default __webpack_public_path__ + "static/summer_containers76-a9912abbec14d0c0ba0de88b67af80c0.webp";